export class Driver {
    public idDriver: number;
    public code: String;
    public firstName : string;
    public lastName : string;
    public telephone : string;
    public cin : string;
    public email : string;
 
    constructor() {}
}
 
export class VehiculeApparence {
   public text:String;
    public id: number;
    
    constructor(text:String,id: number) {
        this.text=  text;
        this.id = id;    
    }
 
}
 
export class DriverLabel {
   public idDriver: number;
   public firstName : string;
    constructor(idDriver: number,firstName : string) {
         this.idDriver = idDriver;      
         this.firstName = firstName;
    }
}


// WEBPACK FOOTER //
// ./src/objects/driver.ts